import { render, staticRenderFns } from "./IntervoiceSpeaker.vue?vue&type=template&id=026015b4&scoped=true"
import script from "./IntervoiceSpeaker.vue?vue&type=script&lang=js"
export * from "./IntervoiceSpeaker.vue?vue&type=script&lang=js"
import style0 from "./IntervoiceSpeaker.vue?vue&type=style&index=0&id=026015b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026015b4",
  null
  
)

export default component.exports